import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock(_component_Icon, {
    stroke: $options.color,
    icon: $options.icon,
    "stroke-width": $options.stroke_width,
    width: $options.icon_size,
    height: $options.icon_size
  }, null, 8 /* PROPS */, ["stroke", "icon", "stroke-width", "width", "height"]))
}